import React, { useState } from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";

import PageContainer from "../layout/PageContainer";

import CmsSearchForm from "../search/CmsSearchForm";
import CmsSearchResults from "../search/CmsSearchResults";

import useCmsSearch from "../../hooks/useCmsSearch";

export default function CmsSearch() {

    const [searchTerm, setSearchTerm] =
        useState("");

    const {
        results,
        error,
        loading,
        search,
        hasMore,
        handleLoadMore,
    } = useCmsSearch();

    const handleSearch = async () => {

        if (!searchTerm.trim()) {
            return;
        }

        await search(searchTerm, {
            count: 10,
            offset: 0,
        });
    };

    return (
        <PageContainer
            title="CMS Suche"
            breadcrumbs={[
                "Home",
                "CMS Suche",
            ]}
        >

            <Grid container spacing={3}>

                {/* Suchformular */}
                <Grid item xs={12}>

                    <Paper sx={{ p: 3 }}>

                        <CmsSearchForm
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            handleSearch={handleSearch}
                            error={error}
                            loading={loading}
                            aiModel="Legcy Homepage Finder"
                        />

                    </Paper>

                </Grid>

                {/* Ergebnisse */}
                {results.length > 0 && (

                    <Grid item xs={12}>

                        <Paper sx={{ p: 3 }}>

                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={2}
                            >

                                <Typography variant="h6">
                                    Ergebnisse
                                </Typography>

                            </Box>

                            <Box
                                sx={{
                                    overflow: "visible",
                                    height: "auto",
                                    maxHeight: "none",
                                    pr: 0,
                                }}
                            >

                                <CmsSearchResults
                                    results={results}
                                    loading={loading}
                                    hasMore={hasMore}
                                    handleLoadMore={handleLoadMore}
                                />

                            </Box>

                        </Paper>

                    </Grid>

                )}

            </Grid>

        </PageContainer>
    );
}